import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Icon from '../../components/AppIcon';

const BookingConfirmation = () => {
  return (
    <>
      <Helmet>
        <title>Booking Confirmed | Northbridge Valuation & Advisory</title>
        <meta
          name="description"
          content="Thank you for booking a consultation with Northbridge Valuation & Advisory. We look forward to speaking with you."
        />
      </Helmet>

      <Header />

      <main className="min-h-screen bg-background flex items-center justify-center py-16 px-6">
        <div className="max-w-xl w-full text-center bg-surface border border-border rounded-2xl shadow-brand-lg px-8 py-12">
          {/* Success Icon */}
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 rounded-full bg-success/10 border border-success/20 flex items-center justify-center">
              <Icon name="CheckCircle" size={40} className="text-success" />
            </div>
          </div>

          {/* Heading */}
          {/* <h1 className="text-3xl font-bold text-text-primary mb-3">
            Booking Confirmed!
          </h1> */}
          <p className="text-text-secondary text-lg mb-2">
            Thank you for scheduling your free consultation.
          </p>
          <p className="text-text-secondary text-sm mb-8">
            A confirmation email has been sent to you. Our team will connect with you at the scheduled time.
          </p>

          {/* What to Expect */}
          <div className="bg-accent/5 border border-accent/15 rounded-xl px-6 py-5 mb-8 text-left">
            <h2 className="text-sm font-semibold text-accent uppercase tracking-wide mb-4">
              What to Expect
            </h2>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-text-secondary text-sm">
                <Icon name="Clock" size={16} className="text-accent mt-0.5 shrink-0" />
                <span>15-minute focused discussion about your valuation needs</span>
              </li>
              <li className="flex items-start space-x-3 text-text-secondary text-sm">
                <Icon name="MessageCircle" size={16} className="text-accent mt-0.5 shrink-0" />
                <span>Expert guidance tailored to your specific situation</span>
              </li>
              {/* <li className="flex items-start space-x-3 text-text-secondary text-sm">
                <Icon name="Shield" size={16} className="text-accent mt-0.5 shrink-0" />
                <span>No obligation — just honest, professional advice</span>
              </li> */}
            </ul>
          </div>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center space-x-2 bg-accent text-white px-6 py-3 rounded-lg text-sm font-medium hover:bg-accent/90 transition-colors duration-200"
            >
              <Icon name="Home" size={16} />
              <span>Back to Home</span>
            </Link>
            <Link
              to="/services"
              className="inline-flex items-center justify-center space-x-2 border border-border text-text-primary px-6 py-3 rounded-lg text-sm font-medium hover:bg-muted transition-colors duration-200"
            >
              <Icon name="Briefcase" size={16} />
              <span>Explore Services</span>
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default BookingConfirmation;
